import React from 'react';
import { lazy, Suspense } from 'react';
import { Grid, CircularProgress, Container, DialogContent, Button } from '@mui/material';
import { RoundedDialog, StandardDialogActions } from '../Components';
const ReactPlayer = lazy(() => import('react-player'));

export default function VideoViewer({ src, audio = false, padding = '16px', borderRadius = '0px' }) {
  return (
    <Container sx={{ height: audio ? '100%' : '65vh' }} maxWidth="xl" disableGutters>
      <Suspense
        fallback={
          <Grid container sx={{ height: '100%' }} alignItems="center" justifyContent="center">
            <CircularProgress />
          </Grid>
        }
      >
        <ReactPlayer
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px',
            padding,
            borderRadius,
          }}
          url={src}
          controls
          playing
          stopOnUnmount={false}
          height={audio ? 100 : '100%'}
          width={'100%'}
        />
      </Suspense>
    </Container>
  );
}

export const VideoDialog = ({ open, onClose, src, audio, size = 'md' }) => {
  return (
    <RoundedDialog open={open} onClose={onClose} maxWidth={size} fullWidth>
      <DialogContent sx={{ padding: 0 }}>
        <VideoViewer src={src} audio={audio} padding="0px" borderRaidus="8px" />
      </DialogContent>
    </RoundedDialog>
  );
};

export const VideoButton = ({ src, title, size = 'medium' }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button variant="soft" color="primary" onClick={() => setOpen(true)} size={size}>
        {title || 'Open Video'}
      </Button>
      <VideoDialog open={open} onClose={() => setOpen(false)} src={src} />
    </>
  );
};
